/***
 * @name string 选中图表类型名称
 *
 * @defaultImg string 默认缺省图
 *
 * @defaultCols string half/whole
 *
 * @defaultRows number
 *
 * fields array 包含字段list
 *        @label string 字段名称
 *        @isMust boolean 是否有必填的标识
 *        @limitNum number|'unlimited(无限制)' 可创建的数量限制
 *        @type string 字段类型 (维度、度量...) dimension｜measure｜any
 *
 ****/

import {
  lineTypeMap,
  lineStyleMap,
  widgetTypeMap,
  emptyValueMap,
} from "../utils/enum.data";

export const remarkPositionMap = {
  title: 1,
  top: 2,
};

function guid() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    var r = (Math.random() * 16) | 0,
      v = c == "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

export const defaultField = (type = "dimension") => {
  return {
    unitCode: "",
    unitName: "",
    belongDimName: null,
    id: guid(),
    name: "",
    sortType: "",
    originIdx: 0,
    aggregatorType: type === "dimension" ? "" : "avg",
    defineType: type === "dimension" ? "dimension" : "measure",
    originType: type === "dimension" ? "dimension" : "measure",
    alias: type === "dimension" ? "dimension" : "measure",
    queryType: type === "dimension" ? "rows" : "values",
  };
};

export const DragPos = () => {
  return { x: 0, y: 0, w: 12, h: 8, i: 1 };
};

export const defaultHelperData = () => {
  return {
    indicatorRowIconMap: {},
    fieldMap: {},
  };
};

export const defaultLineChartConfig = () => {
  return {
  // 线条类型
  lineType: lineTypeMap.line,
  // 线条样式
  lineStyle: lineStyleMap.sty1,
  // 显示标记点
  showPoint: false,
  // 标记点形状
  pointShape: "circle",
  // 线条宽度
  lineWidth: 1,
  // 空值处理
  emptyValue: emptyValueMap.zero,
  };
};

export const styleConfig = () => {
  return {
    commongConfig: {
      gaugeLabelStyle:0,
      showTitle: false,
      showRemark: false,
      remark: "",
      remarkPosition: remarkPositionMap.title,
      backgroundColor: "#fff",
      mergeCells: true,
      pagination: false,
      indicatorIcon: false,
      indicatorStyle: 1,
      // 图表透明度
      columnBackgroundOpacity: 100,
      // 开启渐变效果
      gradientEffect: false,
      // 柱图宽度
      columnWidthRatio: 80,
      // 柱图柱子最大宽度
      maxColumnWidth: null,
      // 数据标签
      labelConfig: {
        show: false,
        showAll: false,
        position: "",
        pieContent: [],
        labelStyle: 1,
        textConfig: {
          fontSize: 12,
          labelFontSize: 12,
          valueFontSize: 12,
          labelColor: "#000",
          color: "#000",
          isBold: false,
          labelIsBold: false,
          valueIsBold: false,
          valueColor: "#000",
          isItalic: false,
          labelIsItalic: false,
          valueIsItalic: false,
          decimalPlaces: 0,
          labelDecimalPlaces: 0,
        },
      },
      legendConfig: {
        show: true,
        position: "top",
      },
      gaugeThemeColor: "#5B8FF9",
      gaugeThemeOpacity: 100,
      gaugeRadiusRatio: 90,
      gaugeInnerTick: 1,
      gaugeInnerTickEnable: true,
      lineChartConfig: defaultLineChartConfig(),
    },
    helperData: {
      ...defaultHelperData(),
    },
  };
};

export const defaultFilterObj = () => {
  return {
    filterList: [],
    filterParentNegated: "N",
  };
};

export const defaultDrillField = () => {
  return {
    label: "钻取/维度",
    isMust: false,
    limitNum: null,
    type: "dimension",
    alias: "drill",
    queryType: "drill",
    chooseFields: [],
  };
};

export const defaultFiledConf = {
  defaultRows: 8,
  dataSetId: "",
  dataSetName: "",
  loading: false,
  measures: [],
  filterObj: {
    ...defaultFilterObj(),
  },
  styleConfig: styleConfig(),
  dwsData: [],
  chartData: [],
  data: {
    data: [],
    meta: [],
    fields: {
      rows: [],
      values: [],
      columns: [],
      valueInCols: false,
    },
    describe: "",
  },
};

export const defaultFilterField = () => {
  return {
    label: "过滤条件",
    isMust: false,
    limitNum: null,
    type: "any",
    alias: "filter",
    queryType: "filter",
    chooseFields: [],
  };
};

export const cTableConf = () => {
  return {
    ...defaultFiledConf,
    name: "交叉表",
    type: widgetTypeMap.Table,
    defaultCols: "whole",
    className: "component-type-cross-table",
    // defaultImg: require("@/assets/img/dashboard/table-none.png"),
    defaultImg: "",
    ...DragPos(),
    fields: [
      defaultDrillField(),
      {
        label: "行/维度",
        isMust: false,
        limitNum: null,
        type: "dimension",
        alias: "dimension",
        queryType: "rows",
        chooseFields: [],
      },
      {
        label: "列/维度/度量",
        isMust: false,
        limitNum: null,
        type: "any",
        alias: "measure",
        queryType: "columns",
        chooseFields: [],
      },
      defaultFilterField()
    ],
    styleComp: {
      type: "c-table-style",
      styleConfig: styleConfig(),
    },
  };
};

export const cIndicatorCard = () => {
  return {
    ...defaultFiledConf,
    name: "指标卡",
    type: widgetTypeMap.IndicatorCard,
    defaultCols: "half",
    className: "component-type-indicator-card",
    // defaultImg: require("@/assets/img/dashboard/indicator-card.png"),
    defaultImg: "",
    ...DragPos(),
    fields: [
      {
        label: "看板标签/维度",
        isMust: false,
        limitNum: 1,
        type: "dimension",
        alias: "dimension",
        queryType: "rows",
        chooseFields: [],
      },
      {
        label: "看板指标/度量",
        isMust: true,
        limitNum: 1,
        type: "measure",
        alias: "measure",
        queryType: "values",
        chooseFields: [],
      },
      defaultFilterField(),
    ],
    styleComp: {
      type: "c-indicator-style",
      styleConfig: styleConfig(),
    },
  };
};

export const cColumnConf = () => {
  return {
    ...defaultFiledConf,
    name: "柱图",
    type: widgetTypeMap.Column,
    defaultCols: "half",
    className: "component-type-bar",
    // defaultImg: require("@/assets/img/dashboard/column-none.png"),
    defaultImg: "",
    ...DragPos(),
    fields: [
      defaultDrillField(),
      {
        label: "类别轴/维度",
        isMust: true,
        limitNum: null,
        type: "dimension",
        alias: "dimension",
        queryType: "rows",
        chooseFields: [],
      },
      {
        label: "值轴/度量",
        isMust: true,
        limitNum: 1,
        type: "measure",
        alias: "measure",
        queryType: "values",
        chooseFields: [],
      },
      {
        label: "颜色图例/维度",
        isMust: false,
        limitNum: 1,
        type: "dimension",
        alias: "dimension",
        queryType: "columns",
        chooseFields: [],
      },
      defaultFilterField(),
    ],
    styleComp: {
      type: "c-column-style",
      styleConfig: styleConfig(),
    },
  };
};
export const cPieConf = () => {
  return {
    ...defaultFiledConf,
    name: "饼图",
    type: widgetTypeMap.Pie,
    defaultCols: "half",
    className: "component-type-pie",
    // defaultImg: require("@/assets/img/dashboard/pie-none.png"),
    defaultImg: "",
    ...DragPos(),
    fields: [
      defaultDrillField(),
      {
        label: "扇区标签/维度",
        isMust: true,
        limitNum: 1,
        alias: "dimension",
        type: "dimension",
        queryType: "rows",
        chooseFields: [],
      },
      {
        label: "扇区角度/度量",
        isMust: true,
        limitNum: 1,
        type: "measure",
        alias: "measure",
        queryType: "columns",
        chooseFields: [],
      },
      defaultFilterField(),
    ],
    styleComp: {
      type: "c-pie-style",
      styleConfig: styleConfig(),
    },
  };
};

export const cLineConf = () => {
  return {
    ...defaultFiledConf,
    name: "折线图",
    type: widgetTypeMap.Line,
    defaultCols: "half",
    className: "component-type-line",
    // defaultImg: require("@/assets/img/dashboard/line-none.png"),
    defaultImg: "",
    ...DragPos(),
    fields: [
      defaultDrillField(),
      {
        label: "类别轴/维度",
        isMust: true,
        limitNum: null,
        type: "dimension",
        alias: "dimension",
        queryType: "rows",
        chooseFields: [],
      },
      {
        label: "值轴/度量",
        isMust: true,
        limitNum: 1,
        type: "measure",
        alias: "measure",
        queryType: "values",
        chooseFields: [],
      },
      {
        label: "颜色图例/维度",
        isMust: false,
        limitNum: 1,
        type: "dimension",
        alias: "dimension",
        queryType: "columns",
        chooseFields: [],
      },
      defaultFilterField(),
    ],
    styleComp: {
      type: "c-line-style",
      styleConfig: styleConfig(),
    },
  };
};

export const cGaugeConf = () => {
  return {
    ...defaultFiledConf,
    name: "仪表盘",
    type: widgetTypeMap.Gauge,
    defaultCols: "half",
    className: "component-type-gauge",
    // defaultImg: require("@/assets/img/dashboard/pie-none.png"),
    defaultImg: "",
    ...DragPos(),
    fields: [
      {
        label: "指针角度/度量",
        isMust: true,
        limitNum: 1,
        type: "measure",
        alias: "measure",
        queryType: "columns",
        chooseFields: [],
      },
      defaultFilterField(),
    ],
    styleComp: {
      type: "c-gauge-style",
      styleConfig: styleConfig(),
    },
  };
};

export const panelMap = {
  [widgetTypeMap.Table]: cTableConf(),
  [widgetTypeMap.Column]: cColumnConf(),
  [widgetTypeMap.Pie]: cPieConf(),
  [widgetTypeMap.Line]: cLineConf(),
  [widgetTypeMap.IndicatorCard]: cIndicatorCard(),
  [widgetTypeMap.Gauge]: cGaugeConf(),
};

export const axisOffset = 36;

export const drillChartTypes = [
  widgetTypeMap.Table,
  widgetTypeMap.Column,
  widgetTypeMap.Pie,
  widgetTypeMap.Line,
];

export const isDrillChart = (chartData) => drillChartTypes.includes(chartData.type);

export const isHasDrill = (chartData) => chartData.fields?.some(f => f.alias === 'drill' && f.chooseFields.length > 0)
